import { cancelled, race, take, call } from "redux-saga/effects";
import axios from "axios";

export function* cancelable(task, ...args) {
  const source = axios.CancelToken.source(); // Create a CancelToken source
  try {
    const { taskResult, cancelAction } = yield race({
      taskResult: call(task, ...args, source.token),
      cancelAction: take('PAGE_CHANGE'),
    });

    if (cancelAction) {
      // Cancel the Axios request using the token
      source.cancel(`Request cancelled for task: ${task.name}`);
      console.log(`Task cancelled: ${task.name}`);
    }
  } finally {
    if (yield cancelled()) {
      console.log('Task cancelled in finally block:', task.name);
    }
  }
}
